






















import store from '@/store'
import router from '@/router'
import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { getLocalItem } from '@/utils'

@Component({
  name: 'GlobalHeader',
})
export default class GlobalHeader extends Vue {
  private client: any = getLocalItem('client');
  private userInfo: any = JSON.parse(localStorage.getItem('client') as any);
  openView() {
    Vue.ls.remove('ACCESS_TOKEN')
    localStorage.removeItem('client')
    this.$router.replace('/user/login')
  }
}
